import { useMutation, useQuery } from '@apollo/client'
import { GRUPO_USUARIOS_QUERY } from '../data/grupo-usuarios'
import { GRUPO_USUARIOS_DOMINIO_QUERY } from '../data/grupo-usuarios-dominio'
import {
  GetGrupoUsuariosDominioQueryQuery,
  GetGrupoUsuariosDominioQueryQueryVariables,
  GetGrupoUsuariosQueryQuery,
  GetGrupoUsuariosQueryQueryVariables,
  GrupoUsuarios,
  GrupoUsuariosInput,
  SalvarGrupoUsuariosMutationMutation,
  SalvarGrupoUsuariosMutationMutationVariables
} from '@/core/types/graphql'
import { SALVAR_GRUPO_USUARIOS } from '../data/salvar-grupo-usuarios'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useCallback } from 'react'
import { useConfirmModal } from '@/core/context/confirm-modal-context'
import { t } from '@lingui/core/macro'
import { Routes } from '@/core/router/routes'
import { GRUPOS_USUARIOS_ATIVOS_QUERY } from '../../grupo-usuarios-core/data/grupo-usuarios-ativos-query'
import { UseFormReset } from 'react-hook-form'
import { GrupoUsuariosValues } from './use-form'

export const useGrupoUsuariosEdicaoQueryHandler = () => {
  const { id } = useParams()
  const { pathname } = useLocation()
  const { askUser } = useConfirmModal()
  const navigate = useNavigate()
  const getGrupoUsuariosDominioQuery = useQuery<
    GetGrupoUsuariosDominioQueryQuery,
    GetGrupoUsuariosDominioQueryQueryVariables
  >(GRUPO_USUARIOS_DOMINIO_QUERY)
  const getGrupoUsuariosQuery = useQuery<
    GetGrupoUsuariosQueryQuery,
    GetGrupoUsuariosQueryQueryVariables
  >(GRUPO_USUARIOS_QUERY, {
    variables: { id: id! },
    skip: false,
    fetchPolicy: 'network-only'
  })
  const [salvarGrupoUsuariosMutation] = useMutation<
    SalvarGrupoUsuariosMutationMutation,
    SalvarGrupoUsuariosMutationMutationVariables
  >(SALVAR_GRUPO_USUARIOS, {
    refetchQueries: [GRUPOS_USUARIOS_ATIVOS_QUERY]
  })

  const salvarGrupoUsuarios = useCallback(
    ({
      grupoUsuariosInput,
      resetForm,
      onOpen,
      onAskUserConfirm
    }: {
      grupoUsuariosInput: GrupoUsuariosInput
      resetForm: UseFormReset<GrupoUsuariosValues>
      onOpen?: () => void
      onAskUserConfirm?: (grupo: GrupoUsuarios) => void
    }) => {
      askUser({
        onConfirm: async () => {
          const result = await salvarGrupoUsuariosMutation({
            variables: { grupoUsuarios: grupoUsuariosInput },
            refetchQueries: [GRUPOS_USUARIOS_ATIVOS_QUERY]
          })
          if (pathname.includes('/gruposUsuarios')) {
            navigate(Routes.GRUPOS_USUARIOS)
          } else {
            onAskUserConfirm?.(result.data?.salvarGrupoUsuarios)
          }
          resetForm()
        },
        onCancel: () => onOpen?.(),
        title: t`Deseja salvar o grupo de usuários?`,
        confirmLabel: t`Salvar`,
        successMessage: t`Grupo de Usuários ${grupoUsuariosInput.nome} salvo com sucesso!`,
        errorMessage: t`Não foi possível salvar Grupo de Usuarios`
      })
    },
    [salvarGrupoUsuariosMutation, askUser]
  )

  return {
    getGrupoUsuariosDominioQuery,
    getGrupoUsuariosQuery,
    salvarGrupoUsuarios
  }
}
